import { cn } from '@/lib/utils'
import React, { useEffect, useRef } from 'react'

const cptCss =
  'h-24 w-24 object-cover transition-all aspect-square rounded-xl border hover:border-2 hover:border-primary hover:scale-105'


interface CptGridProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string
}

const CptGrid = React.forwardRef<HTMLDivElement, CptGridProps>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'grid sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-7 grid-cols-9 gap-2 p-1',
        className,
      )}
      {...props}
    />
  ),
)

CptGrid.displayName = 'CptGrid'

interface CptCardProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode
  children2?: React.ReactNode
  className?: string
  dragHandleProps?: React.HTMLAttributes<HTMLDivElement>
  isDragging?: boolean
}

const CptCard = React.forwardRef<HTMLDivElement, CptCardProps>(
  (
    {
      children,
      children2,
      className,
      dragHandleProps,
      isDragging,
      style,
      onClick,
      ...props
    },
    ref,
  ) => {
    const skipClick = useRef(false)
    useEffect(() => {
      if (isDragging) skipClick.current = true
    }, [isDragging])

    return (
      <div
        className={cn(
          'flex flex-col items-center',
          isDragging && 'relative z-20 opacity-50',
        )}
        ref={ref}
        style={style}
      >
        <div
          className={cn(
            'bg-white border-2 rounded-xl flex items-center justify-center group hover:border-primary w-full',
            dragHandleProps && 'cursor-grab touch-none active:cursor-grabbing',
            className,
          )}
          {...props}
          {...dragHandleProps}
          onClick={(event) => {
            if (skipClick.current) {
              skipClick.current = false
              event.preventDefault()
              event.stopPropagation()
              return
            }
            onClick?.(event)
          }}
        >
          {children}
        </div>
        <div className="min-h-8">{children2}</div>
      </div>
    )
  },
)
CptCard.displayName = 'CptCard'

export { CptCard, cptCss, CptGrid }
